/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Feature_Team_OverageInputs */



/**
* | output |
* | --- |
* | "Overage controls & per-user quotas" |
*
* @param {Plan_Feature_Team_OverageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_team_overage = /** @type {((inputs?: Plan_Feature_Team_OverageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Team_OverageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überverbrauchskontrolle & Nutzer-Kontingente")
	return /** @type {LocalizedString} */ ("Overage controls & per-user quotas")
});